import React, { useEffect, useRef } from 'react';
import { gsap, Sine } from "gsap";
import { Application, Container, Graphics } from 'pixi.js-legacy';
import { ChallengeDemoConfig } from "../../models/Types";
import ChallengeUtils from '../challenges/ChallengeUtils';
import { useTranslation } from 'react-i18next';
import { isDarkModeEnabled } from "../Util";

const BG_COLOR_DARK = 0x1C1B23;
const BG_COLOR_LIGHT = 0xffffff;
const PUZZLE_BG_COLOR_LIGHT = 0xecf0f1;
const PUZZLE_BG_COLOR_DARK = 0xecf0f1;
const PUZZLE_PIECE_TARGET_COLOR_LIGHT = 0xffffff;
const PUZZLE_PIECE_TARGET_COLOR_DARK = 0x1C1B23;
const PUZZLE_PIECE_COLOR_LIGHT = 0x6d4aff;
const PUZZLE_PIECE_COLOR_DARK = 0x6d4aff;

export default function Challenge2DDemo(props: ChallengeDemoConfig) {

  const challengeRef = useRef<any>(null);
  const { t } = useTranslation();

  function drawPuzzlePiece(color: number) {
    const puzzlePiece = new Container();

    const square = new Graphics();
    square.beginFill(color);
    square.drawRoundedRect(5, 5, 20, 20, 3);
    square.endFill();
    puzzlePiece.addChild(square)

    const PUZZLE_EDGES = [{ x: 25, y: 15, radius: 5 }, { x: 15, y: 25, radius: 5 },]
    PUZZLE_EDGES.forEach((edgeDefinition) => {
      const puzzleEdge = new Graphics();
      puzzleEdge.beginFill(color);
      puzzleEdge.drawCircle(edgeDefinition.x, edgeDefinition.y, edgeDefinition.radius);
      puzzleEdge.endFill();
      puzzlePiece.addChild(puzzleEdge);
    });

    return puzzlePiece
  }

  function drawDemoView() {
    const view = challengeRef.current;

    if ((view && view.children.length === 0)) {

      const isDark = isDarkModeEnabled();
      const backgroundColor = isDark ? BG_COLOR_DARK : BG_COLOR_LIGHT;
      const application: Application = ChallengeUtils.generateApplication({
        width: props.width,
        height: props.height,
        backgroundColor
      });

      view.appendChild(application.view);

      const puzzleBG = new Graphics();
      puzzleBG.beginFill(isDark ? PUZZLE_BG_COLOR_DARK : PUZZLE_BG_COLOR_LIGHT);
      puzzleBG.drawRoundedRect(20, 20, props.width - 40, props.height - 40, 5);
      puzzleBG.endFill();

      application.stage.addChild(puzzleBG);

      const puzzlePieceTarget = drawPuzzlePiece(isDark ? PUZZLE_PIECE_TARGET_COLOR_DARK : PUZZLE_PIECE_TARGET_COLOR_LIGHT);
      puzzlePieceTarget.x = props.width * 0.6;
      puzzlePieceTarget.y = props.height * 0.3;
      application.stage.addChild(puzzlePieceTarget);

      const puzzlePiece = drawPuzzlePiece(isDark ? PUZZLE_PIECE_COLOR_DARK : PUZZLE_PIECE_COLOR_LIGHT);
      application.stage.addChild(puzzlePiece);


      gsap.to(puzzlePiece, {
        x: props.width * 0.6,
        y: props.height * 0.3,
        ease: Sine.easeIn,
        duration: 3,
        repeatDelay: 1.5,
        repeat: -1,
        yoyo: true
      })
    }
  }

  useEffect(() => {
    drawDemoView()
  }, [challengeRef]);

  return (
    <div>
      <div ref={challengeRef} className="challenge-canvas-demo-1d"/>
      <h2 className="challenge-canvas-demo-heading">{t('PuzzleChallengeHeader.text')}</h2>
      <p>{t('PuzzleChallengeInfo.text')}</p>

    </div>
  )
}